import { createActionStream } from './internal/createActionStream';

export const { action$, dispatchAction } = createActionStream();
